import React from 'react';
import './specializations.css';
import { useDispatch, useSelector } from "react-redux";
import { setSpecializationFormAction } from "../../redux/rootReducer";
import SpecializationForm from "../SpecializationForm/SpecializationForm";
import { SPECIALIZATION_FORM_INITIAL } from "../../redux/initialStateConstant";
import { GetSpecializationByIdThunk } from "../../redux/thunks/GetSpecializationByIdThunk";
import { RemoveSpecializationThunk } from "../../redux/thunks/RemoveSpecializationThunk";

const Specializations = () => {
    const dispatch = useDispatch();
    const services_settings = useSelector(state => state.services_settings);
    const specialization_form = useSelector(state => state.specialization_form);

    return (
        <>
            { specialization_form.open && <SpecializationForm/> }
            <div className="services_settings services_settings--specializations">
                <div className="services_settings__header services_settings__header--specializations">
                    <div className="services_settings__add button button--blue"
                        onClick={ () => {
                            dispatch(setSpecializationFormAction({
                                ...SPECIALIZATION_FORM_INITIAL,
                                open: true
                            }));
                        } }
                    >
                        Добавить специализацию
                    </div>
                </div>
                {
                    services_settings.specializations.length > 0
                        ?
                        <div className="table">
                            <div className="table__row table__row--header table__row--specializations">
                                <div className="table__cell">№</div>
                                <div className="table__cell">Специализация</div>
                                <div className="table__cell"/>
                                <div className="table__cell"/>
                            </div>
                            {
                                services_settings.specializations.map((elem, index) => {
                                    return (
                                        <div className="table__row table__row--specializations" key={ elem.id }>
                                            <div className="table__cell">{ index + 1}</div>
                                            <div className="table__cell">{ elem.name }</div>
                                            <div className="table__cell table__cell--no-overflow">
                                                <div className="control control--edit"
                                                     onClick={ () => {
                                                         dispatch(GetSpecializationByIdThunk({
                                                             specialization_id: elem.id
                                                         }));
                                                     } }
                                                />
                                            </div>
                                            <div className="table__cell table__cell--no-overflow">
                                                <div className="control control--remove"
                                                     onClick={ () => {
                                                         if (!window.confirm('Вы действительно хотите удалить специализацию?')) return;
                                                         dispatch(RemoveSpecializationThunk({
                                                             specialization_id: elem.id
                                                         }));
                                                     } }
                                                />
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        :
                        <div className="empty__list">Нет сохранённых специализаций</div>
                }
            </div>
        </>
    );
};

export default Specializations;